import { ChangeType } from "__generated__/enums";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import DriveFileRenameOutlineRoundedIcon from "@mui/icons-material/DriveFileRenameOutlineRounded";
import RemoveCircleRoundedIcon from "@mui/icons-material/RemoveCircleRounded";

export enum EntityHistoryType {
	Relative,
	Absolute
}

export const changeColor = {
	[ChangeType.Delete]: "#e64553",
	[ChangeType.Update]: "#F39200",
	[ChangeType.Insert]: "#40a02b",
} as const;

export const changeIcon = {
	[ChangeType.Insert]: <AddCircleRoundedIcon sx={{ fontSize: 18, color: changeColor[ChangeType.Insert] }} />,
	[ChangeType.Update]: <DriveFileRenameOutlineRoundedIcon sx={{ fontSize: 18, color: changeColor[ChangeType.Update] }} />,
	[ChangeType.Delete]: <RemoveCircleRoundedIcon sx={{ fontSize: 18, color: changeColor[ChangeType.Delete] }} />,
} as const;
